import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.7_4a8337f7cc5e1adf1aa3c31aff32febe/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45required_45global from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/middleware/auth-required.global.ts";
import _02_45route_45rules_45global from "/opt/buildhome/repo/apps/console/middleware/02.route-rules.global.ts";
import _03_45rbac_45global from "/opt/buildhome/repo/apps/console/middleware/03.rbac.global.ts";
import _04_45sanitize_45query_45params_45global from "/opt/buildhome/repo/apps/console/middleware/04.sanitize-query-params.global.ts";
import feature_45flags_45global from "/opt/buildhome/repo/apps/console/middleware/feature-flags.global.ts";
export const globalMiddleware = [
  validate,
  _01_45auth_45required_45global,
  _02_45route_45rules_45global,
  _03_45rbac_45global,
  _04_45sanitize_45query_45params_45global,
  feature_45flags_45global
]
export const namedMiddleware = {
  "claim-lab": () => import("/opt/buildhome/repo/apps/claim-lab/middleware/claim-lab.ts"),
  "all-connectors": () => import("/opt/buildhome/repo/apps/console/middleware/all-connectors.ts"),
  "connector-required": () => import("/opt/buildhome/repo/apps/console/middleware/connector-required.ts"),
  "policy-context-required": () => import("/opt/buildhome/repo/apps/console/middleware/policy-context-required.ts"),
  "rialtic-admin": () => import("/opt/buildhome/repo/apps/console/middleware/rialtic-admin.ts"),
  "workspace-system-admin": () => import("/opt/buildhome/repo/apps/console/middleware/workspace-system-admin.ts")
}